import { Eye } from 'iconsax-react';
import type { TablePresentation } from '../../types/presentation.types';

/**
 * Figma “View” chip (node 20472:23336) — opens the left table modal instead
 * of rendering the table inline in the thread. It names its table and row
 * count: an answer with two tables showed two identical “View” chips.
 */
export function AgentTableViewButton({
  block,
  onOpen,
}: {
  block: TablePresentation;
  onOpen: (block: TablePresentation) => void;
}) {
  return (
    <button
      type='button'
      data-slot='agent-table-view'
      aria-label={block.title ? `View ${block.title}` : 'View table'}
      onClick={() => onOpen(block)}
      className='cursor-pointer inline-flex h-10 items-center gap-2 rounded-3xl bg-primary-100 px-3 py-2 text-sm text-primary-1000 transition-opacity hover:opacity-90'
    >
      <Eye
        size={20}
        className='size-5 shrink-0'
        variant='Bulk'
        color='#5b31aa'
      />
      {block.title
        ? `View ${block.title} (${block.rows.length + (block.omittedCount ?? 0)})`
        : 'View'}
    </button>
  );
}
